var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7454 4.34093C27.2804 3.94661 26.5501 3.89019 25.7949 4.19337H25.7937C24.9995 4.51205 3.31186 13.8145 2.42898 14.1946C2.2684 14.2504 0.865962 14.7737 1.01042 15.9393C1.13938 16.9902 2.26654 17.4254 2.40418 17.4756L7.91784 19.3635C8.28364 20.5812 9.63214 25.0737 9.93036 26.0335C10.1164 26.6318 10.4195 27.4179 10.9509 27.5798C11.4171 27.7596 11.8809 27.5953 12.181 27.3597L15.5519 24.233L20.9936 28.4769L21.1232 28.5544C21.4927 28.7181 21.8468 28.7999 22.1847 28.7999C22.4457 28.7999 22.6962 28.7509 22.9355 28.653C23.7508 28.3182 24.0769 27.5413 24.111 27.4533L28.1757 6.32555C28.4237 5.19715 28.079 4.62303 27.7454 4.34093ZM12.7805 20.1187L10.9205 25.0787L9.0605 18.8787L23.3205 8.33869L12.7805 20.1187Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo1);
export default __webpack_public_path__ + "static/media/Telegram-logo-1.8eb45716e179daff34b6962f3e8dc58d.svg";
export { ForwardRef as ReactComponent };